import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { ActivityTemplateJSONAModel } from "interfaces/jsona-models/ActivityTemplateJSONAModel";

export class ActivityTemplateSelector extends BaseApiSelector<ActivityTemplateJSONAModel> {
  constructor() {
    super(ResourceType.ActivityTemplate);
  }
}
